import Image1 from '../../../assets/images/s4_image_1.png'
import Image2 from '../../../assets/images/s4_image_2.png'
import BoxGradient from '../../../assets/images/s4_box_gradient.png'
import Daun1 from '../../../assets/images/s4_daun_1.png'
import Daun2 from '../../../assets/images/s4_daun_2.png'

const Section4 = () => {
    return (
        <div id='about' className="w-full h-screen flex flex-col md:flex-row pt-16 overflow-hidden">
            <div className="w-full md:w-[60%] flex items-center justify-center relative gap-3  px-5 md:px-0 md:pr-10">
                <img src={Daun1} alt="Kebun Jitu" className="max-w-[120px] object-contain z-10 absolute top-0 left-10" loading='lazy'/>
                <img src={Image1} alt="Kebun Jitu" className="max-w-[180px] object-contain z-10" loading='lazy'/>
                <img src={Image2} alt="Kebun Jitu" className="max-w-[180px] object-contain z-10" loading='lazy'/>
                <img src={BoxGradient} alt="Kebun Jitu" className="max-w-[400px] object-contain absolute left-0 bottom-0 z-0" loading='lazy'/>
            </div>

            <div className="w-full md:w-[40%] flex flex-col items-start justify-center gap-3 relative px-5 md:px-0 md:pr-10 pt-10 md:pt-36">
                <h1 className="text-3xl md:text-5xl font-bold text-custom-green">Tentang Kami</h1>
                <p className="text-justify pb-5">
                    <span className="font-bold text-custom-green">Kebun Jitu</span> hadir untuk memberdayakan petani hortikultura Indonesia dengan memberikan analisis tanah instan yang akurat, sehingga mereka dapat bertani dengan lebih cerdas, meningkatkan hasil panen, dan mencapai kesejahteraan yang lebih baik.

                </p>
                <div className="bg-black rounded-full w-full text-white">
                    <div className="w-full rounded-full flex items-center justify-between bg-gradient-to-tr from-custom-green to-custom-green/30 px-3 py-2">
                        <p>Kebun Jitu Presentation</p>
                        <button type='button' className=' flex items-center justify-center gap-2 font-semibold bg-custom-orange px-5 py-1 rounded-full'>
                            Video
                        </button>
                    </div>
                </div>
                <img src={Daun2} alt="Kebun Jitu" className="max-w-[250px] object-contain z-10 self-end" loading='lazy' />
            </div>
        </div>
    )
}

export default Section4